import React, { useState } from "react";
import Draggable from "react-draggable";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import { GetLanguageString } from "../../helper/Components";
import SalaryTransferDetailsBody from "./SalaryTransferDetailsBody";

/** Details modal for "Salary from Amanat Account" requests (req_salary_from_amanat). */
const SalaryTransferNotificationDetails = ({ notificationId, setVisible }) => {
  const [position, setPosition] = useState({ x: 0, y: 0 });

  return (
    <Draggable
      position={position}
      onDrag={(e, ui) => setPosition((prev) => ({ x: prev.x + ui.deltaX, y: prev.y + ui.deltaY }))}
      handle=".modal-header"
      cancel=".no-drag"
    >
      <Modal size="xl" isOpen className="inmodal">
        <ModalHeader className="modal-title" tag="h4">
          <GetLanguageString props="courses_report_details" />
        </ModalHeader>
        <ModalBody>
          <SalaryTransferDetailsBody notificationId={notificationId} />
        </ModalBody>
        <ModalFooter>
          <Button color="white" onClick={() => setVisible(false)}>
            <GetLanguageString props="common_close" />
          </Button>
        </ModalFooter>
      </Modal>
    </Draggable>
  );
};

export default SalaryTransferNotificationDetails;
